/**
 * Text encoding of per-tick inputs (5-bit values from `packControls`) for replays (P10.6) and
 * desync reports (P10.7): one character per value, run-length encoded.
 */

/** Two hours at 66.67 ticks/s: longer logs are refused as garbage. */
const MAX_TICKS = 480_000;

/** 32 symbols for 5 bits; no digits, so run lengths can follow a symbol directly. */
const ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdef";

/** `[0,0,0,5,5,1]` → `"A3F2B"`. */
export function encodeInputs(bits: readonly number[]): string {
	let out = "";
	let i = 0;
	while (i < bits.length) {
		const b = bits[i] as number;
		let n = 1;
		while (bits[i + n] === b) n++;
		out += (ALPHABET[b] ?? "A") + (n > 1 ? String(n) : "");
		i += n;
	}
	return out;
}

export function decodeInputs(text: string): number[] | null {
	const out: number[] = [];
	const re = /([A-Za-f])(\d*)/gy;
	let m: RegExpExecArray | null = re.exec(text);
	let consumed = 0;
	while (m) {
		const value = ALPHABET.indexOf(m[1] as string);
		const count = m[2] ? Number(m[2]) : 1;
		if (value < 0 || !Number.isSafeInteger(count) || count < 1 || out.length + count > MAX_TICKS) {
			return null;
		}
		for (let k = 0; k < count; k++) out.push(value);
		consumed = re.lastIndex;
		m = re.exec(text);
	}
	return consumed === text.length ? out : null;
}
